// Admin API client — /admin/release-notes/* (mirrors the API's release-notes aggregate).

import type {
  AdminReleaseNoteWeekListResponse,
  AdminReleaseNoteListResponse,
  AdminReleaseNoteItemUpdateRequest,
  AdminReleaseNoteItemUpdateResponse,
  AdminReleaseNoteItemCreateRequest,
  AdminReleaseNoteItemCreateResponse,
  AdminReleaseNoteItemDeleteResponse,
  AdminReleaseNoteItemsReorderResponse,
  ReleaseNoteEntry,
} from '@a7y/types';
import { client } from './transport';

export const releaseNotesApi = {
  // Release Notes
  getReleaseNoteWeeks: () => client.get<AdminReleaseNoteWeekListResponse>('/release-notes/weeks'),
  getReleaseNotesByDateRange: (params: { startDate: string; endDate: string }) => {
    const searchParams = new URLSearchParams(params);
    return client.get<AdminReleaseNoteListResponse>(`/release-notes?${searchParams}`);
  },
  getReleaseNote: (id: string) => client.get<ReleaseNoteEntry>(`/release-notes/${id}`),
  updateReleaseNoteItem: (id: string, index: number, data: AdminReleaseNoteItemUpdateRequest) =>
    client.patch<AdminReleaseNoteItemUpdateResponse>(`/release-notes/${id}/items/${index}`, data),
  createReleaseNoteItem: (id: string, data: AdminReleaseNoteItemCreateRequest) =>
    client.post<AdminReleaseNoteItemCreateResponse>(`/release-notes/${id}/items`, data),
  deleteReleaseNoteItem: (id: string, index: number) =>
    client.delete<AdminReleaseNoteItemDeleteResponse>(`/release-notes/${id}/items/${index}`),
  reorderReleaseNoteItems: (id: string, order: number[]) =>
    client.patch<AdminReleaseNoteItemsReorderResponse>(`/release-notes/${id}/items/reorder`, {
      order,
    }),
};
